import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import { useSearchParams } from "react-router-dom";
import useDebouncedValue from "../Utils/Debounce";
import axiosConfig from "../Service/axiosConfig";
import { FaChevronDown } from "react-icons/fa";
import { PiEyeLight } from "react-icons/pi";
import Modal from "react-bootstrap/Modal";
import CustomSelectProps from "../Components/CustomSelect/Customselect";
import "../Pages/Styles/StudentView.css"; // Ensure correct path
import { useNavigate } from "react-router-dom";
import { use } from "react";

const ViewBatch = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowPerPage, setRowPerPage] = useState(30);
  const [searchParams, setSearchParams] = useSearchParams();
  const initialSearch = searchParams.get("search") || "";
  const [search, setSearch] = useState(initialSearch);
  const debouncedSearchTerm = useDebouncedValue(search, 500);

  const [selectedOption, setSelectedOption] = useState(null);
  const [options, setOptions] = useState([]);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // Fetch course options
  useEffect(() => {
    const fetchOptions = async () => {
      setLoading(true);
      try {
        const response = await axiosConfig.get("/accounts/course/");
        const fetchedOptions = response.data?.results?.map((course) => ({
          value: course.id,
          label: course.name,
        }));
        setOptions(fetchedOptions);
        // setSelectedOption(fetchedOptions[0]);
      } catch (err) {
        setError("Error fetching courses");
      } finally {
        setLoading(false);
      }
    };

    fetchOptions();
  }, []);

  // Handle course selection change
  const handleSelectChange = (option) => {
    setSelectedOption(option);
  };

  // Fetch student data based on selected course and search term
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await axiosConfig.get(
          `/accounts/batches_list/?course_id=${
            selectedOption ? selectedOption.value : ""
          }&page=${currentPage}&page_size=${rowPerPage}&search=${debouncedSearchTerm}`
        );
        setData(response.data?.results);
        setTotalRows(response.data.count);
      } catch (error) {
        setError("Error fetching data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [currentPage, rowPerPage, debouncedSearchTerm, selectedOption]);

  const handleNavigate = (batchId) => {
    navigate(`/student/${batchId}`);
  };

  // Columns for DataTable
  const columns = [
    {
      name: "S.No",
      selector: (row, i) => i + 1,
      cell: (row, i) => (currentPage - 1) * rowPerPage + i + 1,
      sortable: true,
    },
    {
      name: "Batch Name",
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: "No.Of Students",
      selector: (row) => row.students_count,
      sortable: true,
    },
    {
      name: "Trainer Name",
      selector: (row) => row.trainer?.user?.full_name,
    },
    {
      name: "Course Name",
      selector: (row) => row.course?.name,
    },
    {
      name: "Actions",
      selector: (row) => row.id,
      cell: (row) => (
        <div className="action-cell">
          <PiEyeLight onClick={() => handleNavigate(row.id)} />
        </div>
      ),
      width: "100px",
    },
  ];

  return (
    <div className="student-view">
      {error && <div className="error-message">{error}</div>}
      <div className="course-inputs">
        <CustomSelectProps
          placeholder="Course Name"
          options={options}
          value={selectedOption}
          onChange={handleSelectChange}
          isSearchable
        />
      </div>
      <h4>All Batches</h4>
      <div className="custom-effective-table">
        <DataTable
          columns={columns}
          data={data}
          pagination
          fixedHeader
          fixedHeaderScrollHeight="400px"
          selectableRowsHighlight
          sortIcon={<FaChevronDown />}
          draggableColumns
          paginationTotalRows={totalRows}
          onChangePage={(page) => setCurrentPage(page)}
          onChangeRowsPerPage={(rowsPerPage) => setRowPerPage(rowsPerPage)}
          progressPending={loading}
        />
      </div>
    </div>
  );
};

export { ViewBatch };
